import packageInfo from '../../package.json';

export const environment = {
  production: false,
  version: `${packageInfo.version}.test`,
  // URL del backend
  url: 'https://adp-api.hub83.cloud'
};
